import { api } from '@/lib/axios';
import type {
  Absence,
  AbsenceType,
  AbsenceTypePayrollFlags,
  AbsenceListMeta,
  CreateAbsencePayload,
  UpdateAbsencePayload,
  ListAbsencesParams,
} from '../types/absence.types';

export const absencesApi = {
  list: (params?: ListAbsencesParams) =>
    api.get<{ data: Absence[]; meta: AbsenceListMeta }>('/absences', { params }),

  get: (id: string) =>
    api.get<{ data: Absence }>(`/absences/${id}`),

  create: (payload: CreateAbsencePayload) =>
    api.post<{ data: Absence }>('/absences', payload),

  update: (id: string, payload: UpdateAbsencePayload) =>
    api.patch<{ data: Absence }>(`/absences/${id}`, payload),

  delete: (id: string) =>
    api.delete<{ message: string }>(`/absences/${id}`),
};

export const absenceTypesApi = {
  list: (params?: { search?: string; isActive?: boolean; limit?: number }) =>
    api.get<{ data: AbsenceType[]; meta: AbsenceListMeta }>('/absence-types', { params }),

  create: (payload: { name: string; color?: string; sortOrder?: number } & AbsenceTypePayrollFlags) =>
    api.post<{ data: AbsenceType }>('/absence-types', payload),

  update: (
    id: string,
    payload: { name?: string; color?: string; sortOrder?: number; isActive?: boolean } & AbsenceTypePayrollFlags,
  ) => api.patch<{ data: AbsenceType }>(`/absence-types/${id}`, payload),

  delete: (id: string) =>
    api.delete<{ message: string }>(`/absence-types/${id}`),
};
